import React, { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import VerticalFilter from '../../components/VerticalFilter';
import CreateNotificationDialog from '../Notification/CreateNotificationDialog';
import { NOTIFICATION_RULE_QUERY, FETCH_NOTIFICATION_QUERY } from '../graphQL/queries';

type specObj = {
  notificationName: string;
  timeSpan: number;
  thresholdValue: number;
  notificationMessage: string;
  thresholdType: string;
  thresholdLimit: number;
  thresholdMet: any;
  email: string;
  id: any;
  searchPeriod: any;
  filterRule: any;
};

type responseObj = {
  GetNotificationData: specObj[];
};

export const ErrorsFilterExpansionPanel = (props: any) => {
  const [formInfo, setFormInfo] = React.useState<any>({});
  const [formData, setFormData] = React.useState<any>({});
  const [filterColumn, setFilterColumn] = React.useState<any>([]);
  const [createNotificationDialog, setCreateNotificationDialog] = React.useState(false);

  const { refetch } = useQuery<responseObj, {}>(FETCH_NOTIFICATION_QUERY, {
    variables: { participant: props.participantCode ? props.participantCode : 'ADMIN' }
  });

  useEffect(() => {
    const filterColumn = props?.filterDataConfig;
    setFilterColumn(filterColumn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.filterDataConfig]);

  const isPresent = (key: string) => {
    if (key === 'initialResponseHttpStatus' || key === 'responseHttpStatus') {
      return (
        props.defaultFilter &&
        props.defaultFilter[key] &&
        (props.defaultFilter[key].fromErrorCode || props.defaultFilter[key].toErrorCode)
      );
    } else if (key === 'service' && (props.isAdminLevel || props.isParticipantLevel)) {
      return props.defaultFilter && props.defaultFilter[key]?.service && props.defaultFilter[key]?.service.length > 0;
    } else {
      return props.defaultFilter && props.defaultFilter[key] && props.defaultFilter[key].length > 0;
    }
  };

  const toColonSperated = (key: string) => {
    if (key === 'retryCount') return props.defaultFilter[key];
    else if (key === 'initialResponseHttpStatus' || key === 'responseHttpStatus')
      return `!${props.defaultFilter[key]?.fromErrorCode}:${props.defaultFilter[key]?.toErrorCode}`;
    else if (key === 'loadIds') {
      if (props.defaultFilter[key].toString().split(',')) {
        let values: any = [];
        values = props.defaultFilter[key].toString().split(',');
        props.defaultFilter[key] = values;
        return props.defaultFilter[key].map((val: string) => val.trim()).join(':');
      } else return props.defaultFilter[key].map((val: string) => val.trim()).join(':');
    } else if (key === 'operations') {
      return props.defaultFilter[key].map((val: any) => val?.value.trim()).join(':');
    } else if (key === 'service' && (props.isAdminLevel || props.isParticipantLevel)) {
      return props.defaultFilter['service'].service.join(',');
    } else return props.defaultFilter[key].map((val: string) => val?.trim()).join(':');
  };
  let search: any = {};
  // search.retryStatus = props.defaultFilter['retryStatus']?.retryStatus;
  if (isPresent('operations')) {
    search.operation = toColonSperated('operations');
  }
  if (isPresent('retryStatus')) {
    search.retryStatus = toColonSperated('retryStatus');
  }

  if (isPresent('loadIds')) {
    search.uniqueCustomerTransactionId = toColonSperated('loadIds');
  }

  if (isPresent('providerLoadIds')) {
    search.uniqueProviderTransactionId = toColonSperated('providerLoadIds');
  }

  if (isPresent('customerCodes')) {
    search.customerCode = toColonSperated('customerCodes');
  }

  if (isPresent('providerCodes')) {
    search.providerCode = toColonSperated('providerCodes');
  }

  if (isPresent('responseStatus')) {
    search.responseStatus = toColonSperated('responseStatus');
  }

  if (isPresent('providerCustomerCodes')) {
    search.providerCustomerCode = toColonSperated('providerCustomerCodes');
  }

  if (isPresent('statusCodes')) {
    search.statusCode = toColonSperated('statusCodes');
  }

  if (isPresent('aggregator')) {
    search.aggregatorCode = toColonSperated('aggregator');
  }
  if (isPresent('service')) {
    search.service = toColonSperated('service');
  }
  if (isPresent('timeTaken')) {
    search.timeTaken = toColonSperated('timeTaken');
  }
  if (isPresent('targetOperation')) {
    search.targetOperation = toColonSperated('targetOperation');
  }
  if (isPresent('retryCount')) {
    search.retryCount = toColonSperated('retryCount');
  }
  // if (isPresent('retryStatus')) {
  //   search.retryStatus = toColonSperated('retryStatus');
  // }
  if (isPresent('targetService')) {
    search.targetService = toColonSperated('targetService');
  }
  if (isPresent('initialResponseHttpStatus')) {
    search.initialResponseHttpStatus = toColonSperated('initialResponseHttpStatus');
  }

  if (isPresent('responseHttpStatus')) {
    search.responseHttpStatus = toColonSperated('responseHttpStatus');
  }

  search = Object.keys(search)
    .map(key => {
      if (key === 'initialResponseHttpStatus' || key === 'responseHttpStatus') {
        return `${key}${search[key]}`;
      } else if (key === 'service') {
        if (search[key] === '') return;
        else return key + '=' + search[key];
      } else return key + '=' + search[key];
    })
    .join(',');

  const applyFilter = (values: any) => {
    props.onSubmit(values);
  };
  const resetFilter = () => {
    props.onReset();
  };

  const handleDialogClose = () => {
    setFormInfo({});
    setCreateNotificationDialog(false);
  };

  const handleCreateNotificationDialogSubmit = () => {
    setCreateNotificationDialog(false);
  };

  // const getFilterRule = () => {

  //   if (props.isAdminLevel)
  //     return ((props.errorCode ? props.errorCode + ',' : '') + (search ? search : '')).replace(/,\s*$/, '');
  //   else if (props.isParticipantLevel) {
  //     return (
  //       (props.participantType === 'CUSTOMER' ? 'customerCode=' : 'providerCode=') +
  //       props.participantCode +
  //       ',' +
  //       ((props.errorCode ? props.errorCode + ',' : '') + (search ? search : '')).replace(/,\s*$/, '')
  //     );
  //   } else if (props.isServiceLevel) {
  //     return (
  //       (props.participantType === 'CUSTOMER' ? 'customerCode=' : 'providerCode=') +
  //       props.participantCode +
  //       ',' +
  //       ((props.errorCode ? props.errorCode + ',' : '') + (search ? search : '')).replace(/,\s*$/, '')
  //     );
  //   }
  // };
  const handleCreateNotificationDialog = () => {
    setFormInfo({});
    setFormData({
      thresholdMet: 'no',
      filterRule: props.isAdminLevel
        ? ((props.errorCode ? props.errorCode + ',' : '') + (search ? search : '')).replace(/,\s*$/, '')
        : props.isParticipantLevel
        ? (props.participantType === 'CUSTOMER' ? 'customerCode=' : 'providerCode=') +
          props.participantCode +
          ',' +
          ((props.errorCode ? props.errorCode + ',' : '') + (search ? search : '')).replace(/,\s*$/, '')
        : (props.participantType === 'CUSTOMER' ? 'customerCode=' : 'providerCode=') +
          props.participantCode +
          ',' +
          ((props.errorCode ? props.errorCode + ',' : '') + (search ? search : '')).replace(/,\s*$/, '')

      // props.isAdminLevel
      //   ? ((props.errorCode ? props.errorCode + ',' : '') + (search ? search : '')).replace(/,\s*$/, '')
      //   : (props.workflowCode ?('service=' +
      //     props.workflowCode +
      //     ',') : '' )+
      //     (props.participantType==='CUSTOMER' ? 'customerCode=' : 'providerCode=') +
      //     props.participantCode +
      //     ',' +
      //     ((props.errorCode ? props.errorCode + ',' : '') + (search ? search : '')).replace(/,\s*$/, '')
    });
    setCreateNotificationDialog(true);
  };
  return (
    <div>
      <VerticalFilter
        data-id="error-filter-comp"
        filterConfig={filterColumn}
        applyFilter={applyFilter}
        resetFilter={resetFilter}
        filterCriteria={props.defaultFilter}
        closeFilter={props.closeFilter}
        handleCreateNotificationDialog={handleCreateNotificationDialog}
        workflowCode={props.workflowCode}
        showAddNotification={props.supportUser ? !props.supportUser : props.workflowCode !== 'freightTracking'}
        workflowList={props.workflowList}
        retryStatusData={props.retryStatusData}
      />
      {createNotificationDialog && (
        <CreateNotificationDialog
          data-id="error-notification-comp"
          createNotificationDialog={createNotificationDialog}
          handleDialogClose={handleDialogClose}
          handleCreateNotificationDialogSubmit={handleCreateNotificationDialogSubmit}
          refresh={refetch}
          formInfo={formInfo}
          formData={formData}
          filterCriteria={props.defaultFilter}
          participantCode={props.participantCode}
          errorCode={props.errorCode}
        />
      )}
    </div>
  );
};
export default ErrorsFilterExpansionPanel;
